import {GetSeferData} from "SeferPetach/GetData";

export async function getUserList(obj) {
    const args = {...obj};
    var payload = await GetSeferData("glusrme", args);
    return (payload);
}
export async function getUserInDepartmentList(user_data) {
    const args = {
        UserId: user_data.UserId,
    };
    var payload = await GetSeferData("glusrdep", args);
    return (payload);
}
export async function getUserBindByID(user_data){
    const args = {
        UserId: user_data.UserId,
    };
    var payload = await GetSeferData("mmgusr", args);
    return (payload);
}
export async function updateUserBind(obj) {
    let args = {
        UserId                  :   obj.UserId,
        Inserted                :   [],        
        Removed                 :   [],
    };
    let i = 0; 
    for(i = 0; i < obj.Current.length;  i++) {
        let contains = obj.Old.includes(obj.Current[i]);
        if (!contains) {
            args.Inserted.push({
                Operation   : 1,
                MentorId    : obj.UserId,
                MenteeId    : obj.Current[i],
            });
        }
    }
    for(i = 0; i < obj.Old.length;      i++) {
        if ((!args.Inserted.includes(obj.Old[i])) && (!obj.Current.includes(obj.Old[i]))) {
            args.Removed.push({
                Operation   : 2,
                MentorId    : obj.UserId,
                MenteeId    : obj.Old[i],
            });
        }
    }
    var payload = await GetSeferData("mmconfig", args);
    return (payload);
}